import React from 'react';
import Scroll from 'react-custom-scroll';
import ColorSpace from './colorSpace';
import ResetColor from './resetColor';
import ColorFormat from './colorFormat';
import MyColors from './myColors';
import TextLabel from '../textLabel/textLabel';
import Divider from '../divider/divider';
import Button from '../button/button';
import Composites from '../../composites/composites';

var onColorLeave = function onColorLeave() {
  var onPreview = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  onPreview(null);
};

export default (function (props) {
  return /*#__PURE__*/React.createElement("div", {
    className: props.getClassName('color-picker-choose-color-dialog')
  }, /*#__PURE__*/React.createElement(ColorSpace, {
    value: props.value,
    onChange: props.onChange
  }), /*#__PURE__*/React.createElement(ResetColor, {
    value: props.value,
    onChange: props.onChange,
    className: "choose-color-dialog-reset"
  }), /*#__PURE__*/React.createElement(ColorFormat, {
    value: props.value,
    onChange: props.onChange
  }), props.myColors ? /*#__PURE__*/React.createElement(Divider, {
    "long": true,
    key: "divider"
  }) : null, props.myColors ? /*#__PURE__*/React.createElement(TextLabel, {
    className: "choose-color-dialog-my-colors-label",
    key: "myColorsLabel",
    shouldTranslate: props.shouldTranslate,
    value: props.textKeys.myColors || 'My Colors'
  }) : null, props.myColors ? /*#__PURE__*/React.createElement("div", {
    className: "choose-color-dialog-my-colors",
    key: "myColors"
  }, /*#__PURE__*/React.createElement(Scroll, null, /*#__PURE__*/React.createElement("div", {
    className: "choose-color-dialog-my-colors-content"
  }, /*#__PURE__*/React.createElement(MyColors, {
    value: props.value,
    colors: props.myColors,
    onChange: props.onChange,
    onColorEnter: props.onPreview,
    onColorLeave: onColorLeave(props.onPreview),
    selectedIndex: props.colorSelectedIndex
  })))) : null, /*#__PURE__*/React.createElement(Composites.ActionSetHorizontal, {
    className: "small flex choose-color-dialog-footer"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "btn-sm btn-confirm-secondary",
    onClick: props.onCancel
  }, props.textKeys.cancel && props.translateIfNeeded(props.textKeys.cancel) || 'Cancel'), /*#__PURE__*/React.createElement(Button, {
    className: "btn-sm btn-confirm-primary",
    onClick: props.onDone
  }, props.textKeys.cancel && props.translateIfNeeded(props.textKeys.done) || 'Done')));
});